import { useNavigate } from 'react-router-dom';
import {
  AppBar, Box, Toolbar, Typography, Container, Button, Paper,
} from '@mui/material';

const pages = [{ name: 'Marcador', route: '/scoreboard' }, { name: 'Jogadores', route: '/players' }, { name: 'Histórico', route: '/history' }, { name: 'Admin', route: '/admin' }];

export function TopBar() {
  const navigate = useNavigate();

  return (
    <Box mb={0}>
      <AppBar
        position="static"
        sx={{ bgcolor: '#ff3aa3' }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Toolbar
            disableGutters
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
            onClick={() => navigate('/scoreboard')}
          >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/suh-logo.svg`}
              alt="Suh Pelada"
              sx={{ height: 34, width: 'auto', display: 'block' }}
            />
            <Typography
              variant="h6"
              noWrap
              sx={{
                fontFamily: 'monospace',
                fontWeight: 700,
                fontSize: '1.5rem',
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              Suh Pelada
            </Typography>
          </Toolbar>
        </Container>
      </AppBar>
      <Paper elevation={3} sx={{ borderRadius: '0px', bgcolor: '#fe66b7' }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
        >
          {pages.map((page) => (
            <Button
              key={page.name}
              onClick={() => navigate(page.route)}
              sx={{ color: 'black', display: 'block' }}
            >
              {page.name}
            </Button>
          ))}
        </Box>
      </Paper>
    </Box>
  );
}
